/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 document.addEventListener('variant:changed', function(event) {
   var variant = event.detail.variant; // Gives you access to the whole variant details
   console.log(variant);
 });
 async function updateItem(data) {
  const result = await fetch("/cart/change.json", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify(data)
  });

  return result.json();
}
 function updateItemById(lineItemId, newQuantity, newProperties = {}) {
  return updateItem({
      id: lineItemId,
      quantity: newQuantity,
      properties: newProperties
  });
}

function addItemEdit(variantId, quantity, form) {
  var card = $(form).closest('div.card');
  card.css('opacity', '0.5');
  //disable button
  $(form).prop('disabled', true);
  CartJS.addItem(variantId, quantity, {}, {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
        $(form).html('Successfully added to quote.');
        card.css('opacity', '1');
        //enable button
        $(form).prop('disabled', false);
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: 1
          }
        }));
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
        $(form).html('There was a problem adding to the quote!');
        card.css('opacity', '1');
        $(form).prop('disabled', false);
    }
  });
}

async function addItem(variantId, quantity) {
  const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify({
          id: variantId,
          quantity: quantity
      })
  })
}
